import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React, { useEffect } from 'react';
import styles from './styles.module.css';
import { useLocation, useHistory } from 'react-router-dom';

const FreezeMembershipIframe = () => {
  const location = useLocation();
  const history = useHistory();
  const { url } = location.state;

  const navigateToMembershipForm = () => {
    history.push('/membership-form');
  };

  useEffect(() => {
    if (!url) {
      navigateToMembershipForm();
    }
  }, [url]);

  useEffect(() => {
    const handleIframeMessage = event => {
      if (
        event.data &&
        event.data.type === 'exit-iframe' &&
        event.data.action === 'home-clicked'
      ) {
        navigateToMembershipForm();
      } else {
        console.warn('FreezeMembershipIframe: Other message received:', event.data);
      }
    };

    // Add event listener for messages from iframe
    window.addEventListener('message', handleIframeMessage);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [history]);

  // Handle iframe handshake after it loads
  const handleIframeLoad = () => {
    const iframe = document.getElementById('FreezeMembershipIframe');
    const parentOrigin = window.location.origin;

    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ type: 'handshake', parentOrigin }, '*');
    } else {
      console.warn(
        'FreezeMembershipIframe: Iframe or contentWindow not available for handshake'
      );
    }
  };

  return (
    <div className={styles.body}>
      <HeaderFooterLayout>
        <iframe
          id="FreezeMembershipIframe"
          src={url}
          width="100%"
          height={document.documentElement.clientHeight - 50}
          title="iframe"
          onLoad={handleIframeLoad}
        />
      </HeaderFooterLayout>
    </div>
  );
};

export default FreezeMembershipIframe;
